import Vue from "vue";
import VueProgressBar from "vue-progressbar";
import axios from "axios";

const ax = axios.create({
  baseUrl: process.env.API_URL || "http://localhost:3000",
});

Vue.use(VueProgressBar, { thickness: "3px" });

let loader;

ax.interceptors.request.use((config) => {
  Vue.prototype.$Progress.start();
  if (loader) {
    loader.hide();
  }
  loader = Vue.prototype.$loading.show();
  return config;
}, (error) => {
  Vue.prototype.$Progress.fail();
  loader.hide();
  return Promise.reject(error);
});

ax.interceptors.response.use((response) => {
  Vue.prototype.$Progress.finish();
  loader.hide();
  return response;
}, (error) => {
  Vue.prototype.$Progress.fail();
  loader.hide();
  return Promise.reject(error);
});

export default ax;



// WEBPACK FOOTER //
// ./src/config/axios.js